

























import { Component, Vue, Watch } from 'vue-property-decorator'
import Snackbar from '../models/snackbar.model'
@Component
export default class SnackbarsHandler extends Vue {
    localSnackbar: Snackbar|null = null
    showSnackbar = false
    get snackbars () {
        return this.$store.state.SnackbarsStore.snackbars
    }

    @Watch('snackbars')
    async onNewSnackbars () {
        this.localSnackbar = this.snackbars[0]
        setTimeout(() => {
            this.showSnackbar = true
        }, 100)
    }

    @Watch('showSnackbar')
    updateSnackbarsQueue () {
        if (this.showSnackbar === false) this.$store.commit('removeLastMessage')
    }
}
